import React from 'react';
import { Link } from 'react-router-dom';
import { useQuiz } from '../contexts/QuizContext';
import QuizQuestion from '../components/QuizQuestion';
import QuizNavigation from '../components/QuizNavigation';
import QuizResult from '../components/QuizResult';
import './QuizPage.css';

const QuizPage = () => {
  const { currentQuestion, quizCompleted } = useQuiz();

  // Definição das perguntas do quiz
  const questions = [
    {
      id: 'pergunta1',
      question: 'Como você descreveria sua barriga atualmente?',
      options: [
        'Pequena pochete abaixo do umbigo',
        'Barriga arredondada e rígida',
        'Barriga flácida, tipo avental'
      ],
      allowMultiple: false
    },
    {
      id: 'pergunta2',
      question: 'Você já tentou dietas ou métodos para perder barriga antes?',
      options: [
        'Sim, já tentei várias vezes, mas sem resultados duradouros',
        'Não, nunca tentei nada específico'
      ],
      allowMultiple: false
    },
    {
      id: 'pergunta3',
      question: 'Você costuma sentir algum desses sintomas?',
      options: [
        'Inchaço abdominal no fim do dia',
        'Baixa energia ou cansaço constante',
        'Ansiedade ou estresse elevado',
        'Inflamações (gastrite, celulite, rinite)',
        'Nenhum desses'
      ],
      allowMultiple: true
    },
    {
      id: 'pergunta4',
      question: 'Qual seu objetivo principal hoje?',
      options: [
        'Perder apenas a gordura localizada',
        'Emagrecer e perder a barriga',
        'Tonificar e definir minha barriga'
      ],
      allowMultiple: false
    }
  ];

  if (quizCompleted) {
    return (
      <div className="quiz-page">
        <div className="quiz-header">
          <h1 className="quiz-title">
            Resultado do Seu Quiz
          </h1>
          <p className="quiz-subtitle">
            Descobrimos qual é o seu tipo de barriga e preparamos um plano personalizado para você
          </p>
        </div>

        <QuizResult />
      
      </div>
    );
  }

  const currentQuestionData = questions[currentQuestion];

  return (
    <div className="quiz-page">
      <div className="quiz-header">
        <h1 className="quiz-title">
          Descubra Qual é o Seu Tipo de Barriga e Como Eliminá-la em 21 Dias
        </h1>
        <p className="quiz-subtitle">
          Responda às perguntas abaixo para descobrir o método mais eficaz para o seu tipo específico de barriga
        </p>
      </div>

      <div className="quiz-content">
        <QuizQuestion
          question={currentQuestionData.question}
          options={currentQuestionData.options}
          questionId={currentQuestionData.id}
          allowMultiple={currentQuestionData.allowMultiple}
        />
        
        <QuizNavigation totalQuestions={questions.length} />
      </div>
    </div>
  );
};

export default QuizPage; 